import {
  createModalCloseElement,
  removeModal,
  removeModalCloseElement,
  showModal,
} from "./Modal/modal";
import { MODAL_ID_PREFIX } from "./constants";
import { fetchReturnUrls, reportIntegrationError } from "./helpers";
import { Store } from "./store";
import { MessageType, StartPaymentOptions } from "./types";

type onInPageStatusChangedType = (
  eventName: MessageType,
  callerName: string,
  callback: () => void
) => void;

export function startPayment(
  options: StartPaymentOptions,
  store: Store,
  onInPageStatusChanged: onInPageStatusChangedType
) {
  const { paymentId, onPaymentRejected, onPaymentSucceeded, onUserCloseModal } =
    options;

  if (typeof paymentId !== "string" || paymentId.trim() === "") {
    const message = reportIntegrationError(
      `startPayment() requires a non-empty "paymentId" (received: ${JSON.stringify(
        paymentId
      )}). Make sure the payment has been created and its id retrieved before calling startPayment().`,
      store.getEnvironment()
    );
    throw new Error(message);
  }

  const urls = {
    success: null,
    failure: null,
  };

  fetchReturnUrls(paymentId, store.getEnvironment()).then((returnUrls) => {
    urls.success = returnUrls.success;
    urls.failure = returnUrls.failure;
  });

  showModal(
    paymentId,
    store.getEnvironment(),
    store.getTranslations(),
    onUserCloseModal,
    store.getCheckoutUrl()
  );

  onInPageStatusChanged(
    "3ds_started",
    "start-payment",
    removeModalCloseElement
  );

  onInPageStatusChanged("3ds_failed", "start-payment", () => {
    const modal = document.getElementById(`${MODAL_ID_PREFIX}-body`);
    if (modal) {
      modal.appendChild(createModalCloseElement(onUserCloseModal));
    }
  });

  onInPageStatusChanged("trigger_success_callback", "start-payment", () => {
    handleTriggerCallback(onPaymentSucceeded, urls.success);
  });

  onInPageStatusChanged("trigger_reject_callback", "start-payment", () => {
    handleTriggerCallback(onPaymentRejected, urls.failure);
  });
}

function handleTriggerCallback(
  callback: (() => void) | undefined,
  url: string | null
) {
  removeModal(false);

  if (callback) {
    callback();
  } else if (url) {
    window.location.assign(url);
  }
}
